import React from 'react';
import { Tooltip, TooltipProps } from '@indigo-ag/component-module';
import { CSSProperties } from 'styled-components';

interface WithConditionalTooltipProps extends Omit<TooltipProps, 'classes'> {
  visible?: boolean;
}

export const tooltipHelperForDisabledElements = (disabled: boolean): CSSProperties => {
  return {
    pointerEvents: disabled ? 'none' : 'auto'
  };
};

export const WithConditionalTooltip: React.FunctionComponent<WithConditionalTooltipProps> = ({
  visible = false,
  children,
  ...tooltipProps
}) => {
  return visible ? <Tooltip {...tooltipProps}>{children}</Tooltip> : <>{children}</>;
};
